import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { DatePicker, Spin, Tabs } from "antd";
import Swal from "sweetalert2";
import { BASE_CRM_URL } from "../../../../components/config/config";
import dayjs from "dayjs";
import axios from "axios";
import ProductTable from "../../../../../core/pagination/ProductTable";
import Select from "react-select";
const Add = () => {
  const { type } = useParams();
  console.log("Document Type:", type);

  const isProposal = type === "proposal";
  const isEstimate = type === "estimate";
  const isCreditNote = type === "creditnote";
  const isInvoice = type === "invoice";

  const showAddressFields = isEstimate || isCreditNote || isInvoice;

  const firstDateLabels = {
    proposal: "Date",
    estimate: "Estimated Date",
    creditnote: "Credit Note Date",
    invoice: "Invoice Date",
  };

  const secondDateLabels = {
    proposal: "Open Till",
    estimate: "Expiry Date",
    invoice: "Due Date",
  };

  const firstDateLabel = firstDateLabels[type];
  const secondDateLabel = secondDateLabels[type];

  //convert proposal-estimate-invoice code

  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);

  const convertFrom = searchParams.get("convertFrom");
  const convertId = searchParams.get("convertId");

  console.log("Document Type:", type);
  console.log("Convert From:", convertFrom);
  console.log("Convert ID:", convertId);

  // const [saving, setSaving] = useState(false);
  const [conversionLoading, setConversionLoading] = useState(false);

  console.log(conversionLoading);

  //estimate add code start

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const navigate = useNavigate();

  const { state } = useLocation();

  console.log(state, "state................................");

  console.log("backtoooo:", state?.type);
  console.log("Customer ID:", state?.customerId);

  const customermainid = state?.customerId;

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  console.log(
    selectedCountry,
    "selectedcountryyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy",
  );

  const [customerOptions, setCustomerOptions] = useState([]);

  const [leadOptions, setLeadOptions] = useState([]);

  const [isCustomerPrefilled, setIsCustomerPrefilled] = useState(false);

  // const [isPrefilled, setIsPrefilled] = useState(false);

  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(15, "day"));

  const [saving, setSaving] = useState(false);

  const [relatedOptions, setRelatedOptions] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);
  const [selectedRelated, setSelectedRelated] = useState(null);

  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [selectedRelatedName, setSelectedRelatedName] = useState("");

  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectLoading, setProjectLoading] = useState(false);

  // const [isReadOnly, setIsReadOnly] = useState(false);

  const [formData, setFormData] = useState({
    adminnote: "",
    clientnote: "",
    terms:
      "1) Warranty: 12 months from the date of installation. The materials are not covered if they fail due to power fluctuation, accidents, or physical damages. 2) Devices once installed or used will not be taken back (No Refund).",
    reference_no: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: null,
    project_id: null,
    adjustment: 0,
    currency: null,

    subject: "",
    content: "",
    proposal_to: "",
    email: "",
    phone: "",
    rel_id: null,
    rel_type: "",
  });

  useEffect(() => {
    if (!state) return;

    if (state.type === "customer") {
      const customer = state.record;

      setSelectedCustomer({
        value: customer.customerId,
        label: customer.company,
      });
      if (state.type === "customer") {
        fillCustomerDetails(state.record);
        setIsCustomerPrefilled(true);
      }
    }
  }, [state, countries]);

  const getRelatedTypes = async () => {
    try {
      setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}RelatedToType`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.RelatedToType,
          name: item.RelatedToType,
        }));

        setRelatedOptions(options);

        // Optional: Set first option as default
        if (options.length > 0) {
          setSelectedRelated(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };
  const getLeads = async () => {
    try {
      // setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}leads/GetLeads`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setLeadOptions(options);

        // // Optional: Set first option as default
        // if (options.length > 0) {
        //   setSelectedRelated(options[0].value);
        // }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCustomerDetails = async (customerId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length > 0) {
        fillCustomerDetails(data.ResultData[0]);
        setIsCustomerPrefilled(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);

        // Optional: Set India as default if available
        const india = options.find((item) => item.label === "India");

        if (india) {
          setSelectedCountry(india.value);
        } else if (options.length > 0) {
          setSelectedCountry(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getLeadDetails = async (leadId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}leads/GetLeadById?LeadId=${leadId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const lead = data.ResultData;

        setFormData((prev) => ({
          ...prev,
          proposal_to: lead.name || "",
          email: lead.email || "",
          phone: lead.phonenumber || "",
          address: lead.address || "",
          city: lead.city || "",
          state: lead.state || "",
          zip: lead.zip || "",
          country: lead.country || null,
          rel_id: lead.id,
          rel_type: "lead",
        }));

        setSelectedCountry(
          countries.find((c) => c.value === lead.country) || null,
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  useEffect(() => {
    getCountries();
    getLeads();
    getRelatedTypes();
    getCustomers();
  }, []);

  const getConversionDetails = async () => {
    if (!convertFrom || !convertId) return;

    try {
      setConversionLoading(true);

      let endpoint = "";

      switch (convertFrom) {
        case "proposal":
          endpoint = `proposal/GetProposal/${convertId}`;
          break;

        case "estimate":
          endpoint = `estimates/GetEstimate/${convertId}`;
          break;

        default:
          console.error("Invalid conversion source:", convertFrom);
          return;
      }

      console.log("Conversion API:", endpoint);

      const response = await axios.get(`${BASE_CRM_URL}${endpoint}`);

      console.log("Conversion Response:", response.data);

      if (response.data?.Status) {
        const data = response.data.ResultData || response.data.Data;

        console.log("Conversion Data:", data);

        prefillConversionData(data);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data?.Message || "Failed to fetch conversion details",
        });
      }
    } catch (error) {
      console.error("Conversion GET Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.Message || "Failed to fetch conversion details",
      });
    } finally {
      setConversionLoading(false);
    }
  };

  const prefillConversionData = (data) => {
    if (!data) return;

    console.log("PREFILL CONVERSION DATA:", data);

    // ==========================================
    // CUSTOMER
    // ==========================================

    const customerId = data.clientid || data.customer_id || data.rel_id;

    const customerName =
      data.ClientName || data.company || data.customer_name || "";

    if (customerId) {
      setSelectedCustomer({
        value: customerId,
        label: customerName,
      });
    }

    // ==========================================
    // CUSTOMER / BILLING DETAILS
    // ==========================================

    setFormData((prev) => ({
      ...prev,

      proposal_to: data.proposal_to || data.ClientName || data.company || "",

      email: data.email || data.MailId || "",

      phone: data.phone || data.PhoneNumber || "",

      street: data.billing_street || data.address || "",

      city: data.billing_city || data.city || "",

      state: data.billing_state || data.state || "",

      zip: data.billing_zip || data.zip || "",

      clientnote: data.clientnote || "",

      adminnote: data.adminnote || "",

      terms: data.terms || "",

      reference_no: data.reference_no || "",

      project_id: data.project_id || null,

      currency: data.currency_id || data.currency || null,

      rel_id: customerId || null,

      rel_type: "customer",
    }));

    // ==========================================
    // COUNTRY
    // ==========================================

    if (data.billing_country || data.country) {
      const countryId = data.billing_country || data.country;

      const country = countries.find(
        (item) => Number(item.value) === Number(countryId),
      );

      setSelectedCountry(country || null);
    }

    // ==========================================
    // PROJECT
    // ==========================================

    if (customerId) {
      getProjects(customerId);

      if (data.project_id) {
        setSelectedProject({
          value: data.project_id,
          label: data.projectname || data.projectName || "",
        });
      }
    }

    // ==========================================
    // DATE
    // ==========================================

    if (data.date || data.datecreated) {
      setStartDate(dayjs(data.date || data.datecreated));
    }

    // ==========================================
    // END DATE
    // ==========================================

    if (data.expirydate || data.due_date || data.dueDate || data.open_till) {
      setEndDate(
        dayjs(
          data.expirydate || data.due_date || data.dueDate || data.open_till,
        ),
      );
    }

    // ==========================================
    // PRODUCT DATA
    // ==========================================

    setProductData({
      items: normalizeConversionItems(data.items || data.Itemable || []),

      subtotal: Number(data.subtotal || 0),

      discount: Number(data.discount_percent || data.discount || 0),

      discountAmount: Number(data.discount_total || data.discountAmount || 0),

      discountType: data.discount_type_name,

      discountTypeId: Number(data.discount_type_id || data.discount_type || 0),

      taxes: data.taxes || [],

      totalTax: Number(data.total_tax || data.totalTax || 0),

      adjustment: Number(data.adjustment || 0),

      total: Number(data.total || 0),

      currencyId: data.currency_id || data.currency || null,
      currencyName: data.currencyName || "",
    });

    setIsCustomerPrefilled(true);
  };

  const normalizeConversionItems = (items) => {
    return (items || []).map((item) => ({
      id: item.item_id,

      productId: item.productId || item.item_id || item.itemid || item.id,

      item: item.item || item.description || "",

      description: item.long_description || item.description || "",

      qty: Number(item.qty || item.quantity || 1),

      rate: Number(item.rate || 0),

      unit: item.unit || "",

      taxes: item.taxes || item.item_taxes || [],
    }));
  };

  useEffect(() => {
    if (convertFrom && convertId && countries.length > 0) {
      getConversionDetails();
    }
  }, [convertFrom, convertId, countries]);

  useEffect(() => {
    if (!state || relatedOptions.length === 0) return;

    console.log("State.......:", state);
    console.log("State Type:", state?.type);

    // =====================================================
    // LEAD
    // =====================================================
    if (state.type === "lead") {
      const lead = state.record;

      // Select "Lead" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label?.toLowerCase() === "lead",
      );

      setSelectedRelated(related || null);
      setSelectedRelatedName("Lead");

      // Fill all lead details
      fillLeadDetails(lead);

      return;
    }

    // =====================================================
    // CUSTOMER
    // =====================================================
    if (state.type === "customer") {
      const customer = state.record;

      // Select "Customer" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label?.toLowerCase() === "customer",
      );

      setSelectedRelated(related || null);
      setSelectedRelatedName("Customer");

      // Fill all customer details
      fillCustomerDetails(customer);

      // Load projects
      if (customer?.customerId) {
        getProjects(customer.customerId);
      }

      return;
    }
  }, [state, relatedOptions, countries]);

  const fillLeadDetails = (lead) => {
    console.log("Lead Data:", lead);

    if (!lead) return;

    setFormData((prev) => ({
      ...prev,
      proposal_to: lead.name || "",
      email: lead.email || "",
      phone: lead.phonenumber || "",
      address: lead.address || "",
      city: lead.city || "",
      state: lead.state || "",
      zip: lead.zip || "",
      country: lead.country || null,
      rel_id: lead.id,
      rel_type: "lead",
    }));

    // setIsPrefilled(true);
    // setIsReadOnly(true);

    setSelectedLead({
      value: lead.id,
      label: lead.name,
    });

    setSelectedCountry(
      countries.find((c) => Number(c.value) === Number(lead.country)) || null,
    );

    setCurrencyId(lead.default_currency);
  };

  const fillCustomerDetails = (customer) => {
    console.log("Customer Data:", customer);

    if (!customer) return;

    setFormData((prev) => ({
      ...prev,
      proposal_to: customer.company || "",
      email: customer.email || "",
      phone: customer.phonenumber || "",
      address: customer.address || "",
      city: customer.city || "",
      state: customer.state || "",
      zip: customer.zip || "",
      country: customer.country || null,
      rel_id: customer.customerId,
      rel_type: "customer",
      currency: customer.default_currency,
    }));

    // setIsPrefilled(true);
    // setIsReadOnly(true);

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });

    setSelectedCountry(
      countries.find((c) => Number(c.value) === Number(customer.country)) ||
        null,
    );

    setCurrencyId(customer.default_currency);
  };

  const [currencyId, setCurrencyId] = useState(formData.currency);

  const [productData, setProductData] = useState({
    items: [],
    subtotal: 0,
    discount: 0,
    discountAmount: 0,
    discountType: "",
    discountMethod: "",
    discountTypeId: null,
    taxes: [],
    totalTax: 0,
    adjustment: 0,
    total: 0,
    currencyId: null,
    currencyName: "",
  });

  console.log(productData, "productDataaaaaaaaaaaaaa");

  const addEstimates = async (e, action) => {
    e.preventDefault();
    console.log("Estimate action:", action);
    try {
      setSaving(true);

      const payload = {
        clientid: selectedCustomer?.value,

        number: 0,
        prefix: "EST-",
        project_id: selectedProject?.value || 0,

        date: startDate ? startDate.format("YYYY-MM-DD") : null,

        expirydate: endDate ? endDate.format("YYYY-MM-DD") : null,

        currency: productData?.currencyId || 5,

        subtotal: Number(productData?.subtotal || 0),

        total_tax: Number(productData?.totalTax || 0),

        total: Number(productData?.total || 0),

        adjustment: Number(productData?.adjustment || 0),

        addedfrom: userId,

        status: 1,

        clientnote: formData.clientnote || "",

        adminnote: formData.adminnote || "",

        discount_percent:
          productData?.discountMethod === "%"
            ? Number(productData?.discount || 0)
            : 0,

        discount_total: Number(productData?.discountAmount || 0),

        discount_type: productData?.discountTypeId,

        terms: formData.terms || "",

        reference_no: formData.reference_no || "",

        sale_agent: userId,

        billing_street: formData.street || formData.address || "",
        billing_city: formData.city || "",
        billing_state: formData.state || "",
        billing_zip: formData.zip || "",
        billing_country: selectedCountry?.value,

        shipping_street: "",
        shipping_city: "",
        shipping_state: "",
        shipping_zip: "",
        shipping_country: selectedCountry?.value || 0,

        include_shipping: 0,

        show_shipping_on_credit_note: 0,

        show_quantity_as: 1,

        items: (productData?.items || []).map((item) => ({
          item_id: item.productId || item.id,

          description: item.item || "",

          long_description: item.description || "",

          qty: Number(item.qty || 0),

          rate: Number(item.rate || 0),

          unit: item.unit || "",

          item_taxes: Array.isArray(item.taxes)
            ? item.taxes.map((tax) => ({
                taxrate: Number(tax.taxrate || 0),
                taxname: tax.label || "",
              }))
            : [],
        })),
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}estimates/AddEstimate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("After API", response);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (state?.Backto === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }
          if (state?.Backto === "lead") {
            navigate(`/crm/viewleads/${customermainid}`);
            return;
          }

          console.log(response.data);
          navigate("/crm/estimates");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message,
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error(error);

      console.error(
        error.response?.data?.Message || "Failed to add Estimates.",
      );
    } finally {
      setSaving(false);
    }
  };

  const addProposal = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        // ==========================================
        // PROPOSAL DETAILS
        // ==========================================

        subject: formData.subject || "",

        content: formData.terms || "",

        addedfrom: userId,

        // ==========================================
        // RELATION
        // ==========================================

        rel_id:
          selectedRelatedName === "Lead"
            ? selectedLead?.value || 0
            : selectedCustomer?.value || 0,

        rel_type: selectedRelatedName === "Lead" ? "lead" : "customer",

        // ==========================================
        // CUSTOMER / LEAD DETAILS
        // ==========================================

        proposal_to: formData.proposal_to || "",

        email: formData.email || "",

        phone: formData.phone || "",

        address: formData.address || "",

        city: formData.city || "",

        state: formData.state || "",

        zip: formData.zip || "",

        country: selectedCountry?.value,

        // ==========================================
        // PROJECT
        // ==========================================

        project_id: selectedProject?.value || 0,

        // ==========================================
        // ASSIGNED
        // ==========================================

        assigned: userId,

        // ==========================================
        // DATE
        // ==========================================

        open_till: endDate ? endDate.format("YYYY-MM-DD") : null,

        // ==========================================
        // TOTALS
        // ==========================================

        subtotal: Number(productData?.subtotal || 0),

        total_tax: Number(productData?.totalTax || 0),

        total: Number(productData?.total || 0),

        adjustment: Number(productData?.adjustment || 0),

        // ==========================================
        // DISCOUNT
        // ==========================================

        discount_percent:
          productData?.discountMethod === "%"
            ? Number(productData?.discount || 0)
            : 0,

        discount_total: Number(productData?.discountAmount || 0),

        discount_type: productData?.discountTypeId || 0,

        // ==========================================
        // CURRENCY
        // ==========================================

        currency: productData?.currencyId || 0,

        // ==========================================
        // STATUS
        // ==========================================

        status: 2,

        // ==========================================
        // HASH
        // ==========================================

        hash: "",

        // ==========================================
        // ITEMS
        // ==========================================

        items: (productData?.items || []).map((item) => ({
          item_id: item.productId || item.id,

          description: item.item || "",

          long_description: item.description || "",

          qty: Number(item.qty || 0),

          rate: Number(item.rate || 0),

          unit: item.unit || "",

          item_taxes: Array.isArray(item.taxes)
            ? item.taxes.map((tax) => ({
                taxrate: Number(tax.taxrate || 0),

                taxname: tax.label || tax.taxname || "",
              }))
            : [],
        })),
      };

      console.log("Add Proposal Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}proposal/AddProposal`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Proposal Response:", response.data);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (state?.type === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }
          if (state?.type === "lead") {
            navigate(`/crm/viewleads/${customermainid}`);
            return;
          }

          navigate("/crm/proposals");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message || "Failed to add Proposal",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Add Proposal Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.Message || "Failed to add Proposal",
        confirmButtonColor: "#d33",
      });
    } finally {
      setSaving(false);
    }
  };

  const addInvoice = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        // ==========================================
        // INVOICE DETAILS
        // ==========================================

        clientid: selectedCustomer?.value || 0,

        number: 0,

        prefix: "INV-",

        date: startDate ? startDate.format("YYYY-MM-DD") : null,

        duedate: endDate ? endDate.format("YYYY-MM-DD") : null,

        project_id: selectedProject?.value || 0,

        // ==========================================
        // CURRENCY
        // ==========================================

        currency: productData?.currencyId || 1,

        // ==========================================
        // TOTALS
        // ==========================================

        subtotal: Number(productData?.subtotal || 0),

        total_tax: Number(productData?.totalTax || 0),

        total: Number(productData?.total || 0),

        adjustment: Number(productData?.adjustment || 0),

        // ==========================================
        // USER / STATUS
        // ==========================================

        addedfrom: userId,

        status: 1,

        sale_agent: userId,

        // ==========================================
        // NOTES
        // ==========================================

        clientnote: formData.clientnote || "",

        adminnote: formData.adminnote || "",

        terms: formData.terms || "",

        // ==========================================
        // DISCOUNT
        // ==========================================

        discount_percent:
          productData?.discountMethod === "%"
            ? Number(productData?.discount || 0)
            : 0,

        discount_total: Number(productData?.discountAmount || 0),

        discount_type: productData?.discountTypeId || "",

        // ==========================================
        // BILLING ADDRESS
        // ==========================================

        billing_street: formData.street || formData.address || "",

        billing_city: formData.city || "",

        billing_state: formData.state || "",

        billing_zip: formData.zip || "",

        billing_country: selectedCountry?.value || 0,

        // ==========================================
        // SHIPPING ADDRESS
        // ==========================================

        shipping_street: "",

        shipping_city: "",

        shipping_state: "",

        shipping_zip: "",

        shipping_country: selectedCountry?.value || 0,

        // ==========================================
        // OTHER
        // ==========================================

        hash: "",

        include_shipping: 0,

        // ==========================================
        // ITEMS
        // ==========================================

        items: (productData?.items || []).map((item) => ({
          item_id: item.productId || item.id,

          description: item.item || "",

          long_description: item.description || "",

          qty: Number(item.qty || 0),

          rate: Number(item.rate || 0),

          unit: item.unit || "",

          item_taxes: Array.isArray(item.taxes)
            ? item.taxes.map((tax) => ({
                taxrate: Number(tax.taxrate || 0),
                taxname: tax.label || "",
              }))
            : [],
        })),
      };

      console.log("Invoice Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}invoice/AddInvoice`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Invoice Response:", response.data);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (state?.type === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }
          if (state?.type === "lead") {
            navigate(`/crm/viewleads/${customermainid}`);
            return;
          }

          navigate("/crm/invoices");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message || "Failed to add Invoice.",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Add Invoice Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.Message || "Failed to add Invoice.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setSaving(false);
    }
  };

  const addCreditNote = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        // ==========================================
        // CREDIT NOTE DETAILS
        // ==========================================

        clientid: selectedCustomer?.value || 0,

        prefix: "CN-",

        // Backend automatically generates the number
        number_format: 0,

        date: startDate ? startDate.format("YYYY-MM-DD") : null,

        // ==========================================
        // NOTES / TERMS
        // ==========================================

        adminnote: formData.adminnote || "",

        terms: formData.terms || "",

        clientnote: formData.clientnote || "",

        // ==========================================
        // CURRENCY
        // ==========================================

        currency: productData?.currencyId || 5,

        // ==========================================
        // TOTALS
        // ==========================================

        subtotal: Number(productData?.subtotal || 0),

        total_tax: Number(productData?.totalTax || 0),

        total: Number(productData?.total || 0),

        adjustment: Number(productData?.adjustment || 0),

        // ==========================================
        // USER / STATUS
        // ==========================================

        addedfrom: userId,

        status: 1,

        project_id: Number(selectedProject?.value || 0),

        // ==========================================
        // DISCOUNT
        // ==========================================

        discount_percent:
          productData?.discountMethod === "%"
            ? Number(productData?.discount || 0)
            : 0,

        discount_total: Number(productData?.discountAmount || 0),

        discount_type: productData?.discountTypeId || "",

        // ==========================================
        // BILLING ADDRESS
        // ==========================================

        billing_street: formData.street || formData.address || "",

        billing_city: formData.city || "",

        billing_state: formData.state || "",

        billing_zip: formData.zip || "",

        billing_country: selectedCountry?.value || 1,

        // ==========================================
        // SHIPPING ADDRESS
        // ==========================================

        shipping_street: "",

        shipping_city: "",

        shipping_state: "",

        shipping_zip: "",

        shipping_country: selectedCountry?.value || 1,

        // ==========================================
        // OTHER CREDIT NOTE SETTINGS
        // ==========================================

        include_shipping: 0,

        show_shipping_on_credit_note: 0,

        show_quantity_as: 1,

        reference_no: formData.reference_no || "",

        // ==========================================
        // ITEMS
        // ==========================================

        items: (productData?.items || []).map((item) => ({
          item_id: item.productId || item.id,

          description: item.item || "",

          long_description: item.description || "",

          qty: Number(item.qty || 0),

          rate: Number(item.rate || 0),

          unit: item.unit || "",

          item_taxes: Array.isArray(item.taxes)
            ? item.taxes.map((tax) => ({
                taxrate: Number(tax.taxrate || 0),
                taxname: tax.label || "",
              }))
            : [],
        })),
      };

      console.log("Credit Note Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}creditnotes/AddCreditNote`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Credit Note Response:", response.data);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (state?.type === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }
          if (state?.type === "lead") {
            navigate(`/crm/viewleads/${customermainid}`);
            return;
          }

          navigate("/crm/creditnotes");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message || "Failed to add Credit Note.",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error("Add Credit Note Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.Message || "Failed to add Credit Note.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setSaving(false);
    }
  };

  const [activeTab, setActiveTab] = useState("basic");
  const handleNext = () => {
    const tabKeys = tabItems.map((tab) => tab.key);
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };
  const handlePrevious = () => {
    const tabKeys = tabItems.map((tab) => tab.key);
    const currentIndex = tabKeys.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }
  };

  const tabItems = [
    {
      key: "basic",
      label: (
        <>
          <i className="bi bi-person-lines-fill me-2"></i>
          Customer
        </>
      ),
      children: (
        <>
          <div className="row">
            {isProposal && (
              <>
                {/* Subject */}
                <div className="col-4 mb-2">
                  <label>Subject</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Subject"
                    value={formData.subject}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        subject: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Related */}
                <div className="col-2 mb-2">
                  <label>Related (Customer/Lead)</label>

                  <Select
                    options={relatedOptions}
                    value={selectedRelated}
                    // styles={prefillSelectStyles}
                    // isDisabled={isSelectReadOnly(selectedRelated)}
                    loading={relatedLoading}
                    placeholder="Select Related"
                    onChange={(value) => {
                      console.log("Selected Value:", value);

                      setSelectedRelated(value);
                      setSelectedRelatedName(value?.name);

                      setSelectedLead(null);
                      setSelectedCustomer(null);
                      setSelectedProject(null);
                    }}
                  />
                </div>

                {/* Lead */}
                {selectedRelatedName === "Lead" && (
                  <div className="col-3 mb-3">
                    <label>Lead</label>

                    <Select
                      options={leadOptions}
                      value={selectedLead}
                      // styles={prefillSelectStyles}
                      // isDisabled={isSelectReadOnly(selectedLead)}
                      placeholder="Select Lead"
                      onChange={async (option) => {
                        setSelectedLead(option);

                        if (option?.value) {
                          await getLeadDetails(option.value);
                        }
                      }}
                    />
                  </div>
                )}

                {/* Customer - Proposal */}
                {selectedRelatedName === "Customer" && (
                  <div className="col-3 mb-3">
                    <label>Customer</label>

                    <Select
                      // options={customerOptions}
                      // value={selectedCustomer}
                      // styles={prefillSelectStyles}
                      // isDisabled={isSelectReadOnly(selectedCustomer)}
                      // placeholder="Select Customer"
                      // onChange={async (option) => {
                      //   setSelectedCustomer(option);

                      //   if (option?.value) {
                      //     await getCustomerDetails(option.value);
                      //     getProjects(option.value);
                      //   }
                      // }}

                      showSearch
                      placeholder="Select Customer"
                      optionFilterProp="label"
                      className={`w-100 ${
                        isCustomerPrefilled ? "prefilled-select" : ""
                      }`}
                      style={{ height: 38 }}
                      options={customerOptions}
                      value={selectedCustomer}
                      onChange={(value) => {
                        setSelectedCustomer(value.value);
                        getCustomerDetails(value.value);
                        getProjects(value.value);
                      }}
                    />
                  </div>
                )}

                {/* Project */}
                {selectedCustomer && (
                  <div className="col-3 mb-3">
                    <label>Project</label>

                    <Select
                      options={projectOptions}
                      // isDisabled={isSelectReadOnly(selectedProject)}
                      // styles={prefillSelectStyles}
                      value={selectedProject}
                      isLoading={projectLoading}
                      placeholder="Select Project"
                      onChange={(option) => setSelectedProject(option)}
                    />
                  </div>
                )}

                {/* Email */}
                <div className="col-3 mb-2">
                  <label>Email</label>

                  <input
                    type="email"
                    className="form-control"
                    // style={prefillStyle}
                    // disabled={isReadOnly && !!formData.email}
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Phone */}
                <div className="col-3 mb-2">
                  <label>Phone</label>

                  <input
                    type="text"
                    className="form-control"
                    // style={prefillStyle}
                    // disabled={isReadOnly && !!formData.phone}
                    placeholder="Enter PhoneNumber"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone: e.target.value,
                      }))
                    }
                  />
                </div>
              </>
            )}

            {/* ===================================================== */}
            {/* CUSTOMER                                              */}
            {/* Estimate / Credit Note / Invoice                      */}
            {/* One reusable Customer dropdown                        */}
            {/* ===================================================== */}

            {/* <div className="row"> */}
            {/* {!isProposal && (
              <div className="mb-2 col-3">
                <label>Customer</label>

                <Select
                  showSearch
                  placeholder="Select Customer"
                  optionFilterProp="label"
                  className={`w-100 ${
                    isCustomerPrefilled ? "prefilled-select" : ""
                  }`}
                  style={{ height: 38 }}
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={(value) => {
                    console.log(value, "valuuuuuuuuuuuuuuuuuuuuu");
                    setSelectedCustomer(value.value);
                    getCustomerDetails(value.value);
                  }}
                />
              </div>
            )} */}
            {!isProposal && (
              <div className="col-3 mb-3">
                <label>Customer</label>

                <Select
                  // options={customerOptions}
                  // value={selectedCustomer}
                  // styles={prefillSelectStyles}
                  // isDisabled={isSelectReadOnly(selectedCustomer)}
                  // placeholder="Select Customer"
                  // onChange={async (option) => {
                  //   setSelectedCustomer(option);

                  //   if (option?.value) {
                  //     await getCustomerDetails(option.value);
                  //     getProjects(option.value);
                  //   }
                  // }}

                  showSearch
                  placeholder="Select Customer"
                  optionFilterProp="label"
                  className={`w-100 ${
                    isCustomerPrefilled ? "prefilled-select" : ""
                  }`}
                  style={{ height: 38 }}
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={(value) => {
                    setSelectedCustomer(value.value);
                    getCustomerDetails(value.value);
                    getProjects(value.value);
                  }}
                />
              </div>
            )}

            {/* Project */}
            {!isProposal && selectedCustomer && (
              <div className="col-3 mb-3">
                <label>Project</label>

                <Select
                  options={projectOptions}
                  // isDisabled={isSelectReadOnly(selectedProject)}
                  // styles={prefillSelectStyles}
                  value={selectedProject}
                  isLoading={projectLoading}
                  placeholder="Select Project"
                  onChange={(option) => setSelectedProject(option)}
                />
              </div>
            )}

            {/* ===================================================== */}
            {/* DATE FIELDS                                           */}
            {/* One reusable first date                              */}
            {/* ===================================================== */}

            <div className="mb-2 col-3">
              <label>{firstDateLabel}</label>

              <DatePicker
                value={startDate}
                format="DD-MM-YYYY"
                // style={prefillStyle}
                className="w-100"
                onChange={(date) => {
                  setStartDate(date);

                  /*
                   * Proposal and Estimate automatically
                   * set the second date to +15 days.
                   */
                  if ((isProposal || isEstimate) && date) {
                    setEndDate(date.add(15, "day"));
                  } else if (isProposal || isEstimate) {
                    setEndDate(null);
                  }
                }}
              />
            </div>

            {/* ================================================= */}
            {/* SECOND DATE                                        */}
            {/* Proposal  -> Open Till                            */}
            {/* Estimate  -> Expiry Date                          */}
            {/* Invoice   -> Due Date                             */}
            {/* Credit Note -> No second date                     */}
            {/* ================================================= */}

            {(isProposal || isEstimate || isInvoice) && (
              <div className="mb-2 col-3">
                <label>{secondDateLabel}</label>

                <DatePicker
                  value={endDate}
                  format="DD-MM-YYYY"
                  // style={prefillStyle}
                  className="w-100"
                  onChange={(date) => setEndDate(date)}
                />
              </div>
            )}

            {/* ================================================= */}
            {/* REFERENCE NUMBER                                   */}
            {/* Estimate + Credit Note                            */}
            {/* ================================================= */}

            {(isEstimate || isCreditNote) && (
              <div className="mb-2 col-3">
                <label>Reference #</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Reference #"
                  value={formData.reference_no || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      reference_no: e.target.value,
                    }))
                  }
                  required
                />
              </div>
            )}
            {/* </div> */}
            {/* ===================================================== */}
            {/* COMMON ADDRESS                                        */}
            {/* Estimate + Credit Note + Invoice                      */}
            {/* One copy only                                         */}
            {/* ===================================================== */}

            {showAddressFields && (
              <>
                {/* Street */}
                <div className="mb-2 col-3">
                  <label>(Bill To) Street</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Street"
                    value={formData.address}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        address: e.target.value,
                      }))
                    }
                    // style={{
                    //   backgroundColor: selectedCustomer ? "#EAF4FF" : "#fff",
                    // }}
                  />
                </div>

                {/* City */}
                <div className="mb-2 col-3">
                  <label>City</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter City"
                    value={formData.city}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                    // style={{
                    //   backgroundColor: selectedCustomer ? "#EAF4FF" : "#fff",
                    // }}
                  />
                </div>

                {/* State */}
                <div className="mb-2 col-3">
                  <label>State</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter State"
                    value={formData.state}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        state: e.target.value,
                      }))
                    }
                    // style={{
                    //   backgroundColor: selectedCustomer ? "#EAF4FF" : "#fff",
                    // }}
                  />
                </div>

                {/* Zip Code */}
                <div className="mb-2 col-3">
                  <label>Zip Code</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Zip Code"
                    value={formData.zip}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        zip: e.target.value,
                      }))
                    }
                    // style={{
                    //   backgroundColor: selectedCustomer ? "#EAF4FF" : "#fff",
                    // }}
                  />
                </div>

                {/* Country */}
                <div className="mb-2 col-3">
                  <label>Country</label>

                  <Select
                    style={{ height: 38 }}
                    className={`w-100 ${
                      isCustomerPrefilled ? "prefilled-select" : ""
                    }`}
                    placeholder="Select Country"
                    options={countries}
                    value={selectedCountry}
                    loading={countryLoading}
                    onChange={(value) => {
                      setSelectedCountry(value);
                      setIsCustomerPrefilled(false);
                    }}
                    showSearch
                    optionFilterProp="label"
                    // filterOption={(input, option) =>
                    //   (option?.label ?? "")
                    //     .toLowerCase()
                    //     .includes(input.toLowerCase())
                    // }
                  />
                </div>

                {/* Admin Note */}
                <div
                  className={`mb-2 ${
                    ["creditnote", "invoice"].includes(type) ? "col-9" : "col-9"
                  }`}
                >
                  <label>Admin Note(Internal)</label>

                  <textarea
                    className="form-control"
                    placeholder="Enter text here"
                    rows="1"
                    value={formData.adminnote}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        adminnote: e.target.value,
                      }))
                    }
                  />
                </div>
              </>
            )}
          </div>
        </>
      ),
    },

    ...(type !== "estimate" && type !== "creditnote" && type !== "invoice"
      ? [
          {
            key: "address",
            label: (
              <>
                <i className="bi bi-geo-alt me-2"></i>
                Address
              </>
            ),
            children: (
              <>
                <div className="row">
                  <div className="col-4 mb-3">
                    <label>To</label>
                    <textarea
                      className="form-control"
                      placeholder="Eneter Name"
                      // style={prefillStyle}
                      // disabled={isReadOnly && !!formData.proposal_to}
                      value={formData.proposal_to}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          proposal_to: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-8 mb-3">
                    <label>Street</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Address"
                      // style={prefillStyle}
                      // disabled={isReadOnly && !!formData.address}
                      value={formData.address}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          address: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-3 mb-3">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="enter city"
                      // style={prefillStyle}
                      // disabled={isReadOnly && !!formData.city}
                      value={formData.city}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          city: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>State</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="state"
                      // style={prefillStyle}
                      // disabled={isReadOnly && !!formData.state}
                      value={formData.state}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          state: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>Country</label>
                    <Select
                      placeholder="select country"
                      options={countries}
                      value={selectedCountry}
                      onChange={(option) => {
                        setSelectedCountry(option);

                        setFormData((prev) => ({
                          ...prev,
                          country: option?.value || null,
                        }));
                      }}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label>Zip Code</label>
                    <input
                      type="text"
                      placeholder="enter zip"
                      className="form-control"
                      // style={prefillStyle}
                      // disabled={isReadOnly && !!formData.zip}
                      value={formData.zip}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          zip: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </>
            ),
          },
        ]
      : []),

    {
      key: "items",
      label: (
        <>
          <i className="bi bi-cart3 me-2"></i>
          Items & Totals
        </>
      ),
      children: (
        <>
          <ProductTable
            currencyId={currencyId}
            CurrencyName={productData.currencyName}
            discount_type={productData.discountType}
            discount_type_id={productData.discountTypeId}
            initialDiscount={productData.discount}
            initialItems={productData.items}
            adjustment={productData.adjustment}
            onProductDataChange={setProductData}
          />
        </>
      ),
    },
    {
      key: "terms",
      label: (
        <>
          <i className="bi bi-file-text me-2"></i>
          Terms & Conditions
        </>
      ),
      children: (
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Terms & Conditions</label>

              <textarea
                className="form-control"
                rows={8}
                name="terms"
                value={formData.terms || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    terms: e.target.value,
                  }))
                }
                placeholder="Enter terms and conditions"
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  //helper methods code
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("========== SUBMIT ==========");
    console.log("type:", type);
    console.log("activeTab:", activeTab);

    if (type === "proposal") {
      console.log("Calling addProposal");
      addProposal(e, "save");
    } else if (type === "estimate") {
      console.log("Calling addEstimates");
      addEstimates(e, "save");
    } else if (type === "creditnote") {
      console.log("Calling addCreditNote");
      addCreditNote(e, "save");
    } else if (type === "invoice") {
      console.log("Calling addInvoice");
      addInvoice(e, "save");
    }
  };

  const backPaths = {
    estimate: "/crm/estimates",
    invoice: "/crm/invoices",
    creditnote: "/crm/creditnotes",
    proposal: "/crm/proposals",
  };
  const formattedType = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "";

  return (
    <div className="page-wrapper">
      {saving && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="page-header">
          <div className="add-item">
            <div className="d-flex flex-column">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    New {formattedType}
                  </h4>
                </ol>
              </nav>
              <p className="text-muted">Create a New {formattedType} here</p>
            </div>
          </div>

          <div className="">
            <Link
              to={backPaths[type]}
              className="btn btn-dark btn-icon btn-sm "
            >
              <i className="fa-solid fa-arrow-left fa-lg text-white"></i>
            </Link>
          </div>
        </div>

        <div className="card">
          {/* <div className="card-header ">
            <h4 className="text-primary">{formData.client}</h4>
          </div> */}
          <div className="card-body pt-0">
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (
                  e.key === "Enter" &&
                  e.target.tagName !== "TEXTAREA" &&
                  e.target.tagName !== "INPUT"
                ) {
                  e.preventDefault();
                }
              }}
            >
              <Tabs
                // defaultActiveKey="1"
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                size="large"
                tabBarGutter={30}
                animated
              />

              {/* <div className="d-flex justify-content-end mt-2">
                <button type="submit" className="btn btn-info me-2">
                  <i className="fa fa-left-arrow"></i>
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => setSubmitAction("save")}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div> */}

              <div className="d-flex justify-content-end gap-2 mt-3">
                {activeTab !== "basic" && (
                  <button
                    type="button"
                    onClick={handlePrevious}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#6c757d",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Previous"
                  >
                    {" "}
                    <i className="fa fa-arrow-left" />{" "}
                  </button>
                )}{" "}
                {activeTab !== "terms" && (
                  <button
                    type="button"
                    onClick={handleNext}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#f1f51e",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Next"
                  >
                    <i className="fa fa-arrow-right" />
                  </button>
                )}
                {activeTab === "terms" && (
                  <button
                    type="submit"
                    disabled={saving}
                    className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      width: "35px",
                      height: "35px",
                      backgroundColor: "#07f083",
                      color: "#fff",
                      border: "none",
                    }}
                    title="Save"
                  >
                    {saving ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      />
                    ) : (
                      <i className="fa fa-check" />
                    )}
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default Add;
